<div id="editEndUserInfo" class="subBlockContainer entry-loader">
  <child-header [title]="title" (closeEvent)="close()"></child-header>
  <div class="subBlockContent">
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
      <div [formGroup]="userFormGroup">
        <div class="userinfo">
          <mat-form-field hidden>
            <input matInput formControlName="salesType">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="contactNameValidate" formControlName="contactName" placeholder="CONTACT NAME" required>
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'" hidden>
            <input matInput class="endUserCsnValidate" formControlName="endUserCsn" placeholder="END USER CSN">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="companyNameValidate" formControlName="companyName" placeholder="COMPANY NAME"
              required>
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="addressValidate" formControlName="address" placeholder="ADDRESS 1" required>
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="address2Validate" formControlName="address2" placeholder="ADDRESS 2">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="suburbValidate" #myAutocompleteTriggerSub="matAutocompleteTrigger" (input)="onInputSub($event)" [matAutocomplete]="autoSuburb" formControlName="suburb"
              placeholder="SUBURB" (keydown.Tab)="chooseAutoCompletSuburb($event)" (suburb)="startFilterSub($event)" required>
            <mat-autocomplete #autoSuburb="matAutocomplete">
              <mat-option *ngFor="let option of filteredSub" [value]="option?.suburb"
                (click)="chooseAutoComplete(option)">
                {{option?.suburb+", "+option?.state+", "+option?.postcode}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <ng-select class="customDropdwon stateValidate mat-form-field" [items]="stateList" bindValue="state"
              bindLabel="state" placeholder="STATE *" formControlName="state"></ng-select>
          <mat-form-field [floatLabel]="'always'">
              <input matInput  formControlName="country" placeholder="COUNTRY">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="postcodeValidate" #myAutocompleteTriggerPostcode="matAutocompleteTrigger" (input)="onInputPostcode($event)" maxlength="4" (keypress)="isNumberKey($event)"
              formControlName="postcode" (postcode)="startFilterPostcode($event)" (keydown.Tab)="chooseAutoCompletPostcode($event)" [matAutocomplete]="autoPostcode" placeholder="POST CODE" required>
            <mat-autocomplete #autoPostcode="matAutocomplete">
              <mat-option *ngFor="let option of filteredPostCode" [value]="option?.postcode"
                (click)="chooseAutoComplete(option)">
                {{option?.suburb+", "+option?.state+", "+option?.postcode}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="phoneNoValidate" (keypress)="isNumberKey($event)" formControlName="phoneNo" placeholder="PHONE">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="emailValidate" formControlName="email" placeholder="EMAIL" required>
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'" hidden>
            <input matInput class="endUserContractValidate" formControlName="endUserContract"
              placeholder="END-USER CONTRACT">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'" hidden>
            <input matInput class="aceValidate" formControlName="ace" placeholder="ACE / RENEWAL ID">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'" hidden>
            <input matInput class="resellerCsnValidate" formControlName="resellerCsn" placeholder="RESELLER CSN">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'" hidden>
            <input matInput class="serialNumberValidate" formControlName="serialNumber" placeholder="SERIAL NUMBER">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'" hidden>
            <input matInput class="resellerEmailValidate" formControlName="resellerEmail" placeholder="RESELLER EMAIL">
          </mat-form-field>
        </div>
      </div>
    </div>
    <loading-screen *ngIf="!loadContent" backDropWidth='350' [showBlurTable]="false"
      (currentLoadingStatus)="onLoading($event)"></loading-screen>
    <div class="align-center">
      <button id="saveuser" class="button button-red button-large" (click)="saveEndUser()">Save</button>
    </div>
    <div class="align-center" >
      <p id="deleteButton"><a id="buttonDelete" class="deleteBtn" (click)="deleteEndUser()">Delete</a>
      </p>
    </div>
  </div>
</div>
<router-outlet></router-outlet>